const createDefaultFilters = () => ({
  searchTerm: '',
  selectedDate: '',
  selectedCity: '',
  selectedVendor: '',
  allInvoicesDateFrom: null,
  allInvoicesDateTo: null,
  allInvoicesStatus: '',
});

const TAB_KEYS = [
  'action-required',
  'stopped-invoices',
  'all-invoices',
  'archive',
  'all-invoices-full',
];

const filtersByTab = Object.fromEntries(TAB_KEYS.map((tab) => [tab, createDefaultFilters()]));

export const PO_WORKFLOW_MODULE_PATH = '/poWorkflowManagement';

export const isPoWorkflowModulePath = (pathname) =>
  pathname === PO_WORKFLOW_MODULE_PATH || pathname.startsWith(`${PO_WORKFLOW_MODULE_PATH}/`);

export const getPoWorkflowFilters = (tab) => {
  if (!filtersByTab[tab]) {
    filtersByTab[tab] = createDefaultFilters();
  }
  return filtersByTab[tab];
};

export const setPoWorkflowFilters = (tab, partial) => {
  Object.assign(getPoWorkflowFilters(tab), partial);
};

export const resetPoWorkflowFilters = () => {
  TAB_KEYS.forEach((tab) => {
    filtersByTab[tab] = createDefaultFilters();
  });
};
